// export default {
//     api: {
//         //服务器地址
//         domain:process.env.NODE_ENV == 'production' ? 'https://pcapi.yssoft.cn/':'https://htapi.yssoft.cn',
//         //api地址
//         base_url: process.env.NODE_ENV == 'production' ? `https://pcapi.yssoft.cn/admin/rpc` : 'https://htapi.yssoft.cn/admin/rpc',

//         //请求超时时间（单位S）
//         timeout: 30,
//     },

//     login_websocket_url:  process.env.NODE_ENV == 'production' ? `106.55.234.71:39898` : '106.52.223.227:39898', 

//     page: {
//         //每页显示条数
//         page_size: 30
//     },

//     upload_url :process.env.NODE_ENV == 'production' ? `https://pcapi.yssoft.cn/admin/rpc` : 'https://htapi.yssoft.cn/admin/rpc',

//     //文件服务器地址
//     file_srv:process.env.NODE_ENV == 'production' ? 'https://pcapi.yssoft.cn/':'https://htapi.yssoft.cn/'
// }


// 海腾正式
export default {
    api: {
        //服务器地址
        domain:'https://ht.smallzone.work',
        //api地址
        base_url:  'https://ht.smallzone.work/admin/rpc',

        //请求超时时间（单位S）
        timeout: 1000,
    },

    login_websocket_url:  'ht.smallzone.work:39898', 

    page: {
        //每页显示条数
        page_size: 30
    },

        //文件服务器地址
    upload_url: 'https://ht.smallzone.work/admin/rpc',
    //文件服务器地址
    file_srv:'https://ht.smallzone.work'
}

